module.exports = __webpack_public_path__ + "media/images/count-box-bg-teal-ea4921ec.svg";